import React from 'react'
import { Button, ButtonProps, StackProps, VStack, Text, Icon } from '@chakra-ui/react'

type OutlineButtonProps = ButtonProps

export const OutlineButton: React.FC<OutlineButtonProps> = ({ children, colorScheme, ...rest }) => {
  return (
    <Button
      height={{ base: 10, md: 12 }}
      rounded="0"
      backgroundColor="white"
      border="1px solid"
      borderColor="gray.300"
      color="gray.900"
      textTransform="uppercase"
      letterSpacing="0.02em"
      fontWeight="600"
      _hover={{
        backgroundColor: 'brand.50',
        borderColor: 'brand.500',
        color: 'brand.500',
        transform: 'translateY(-1px)',
        shadow: 'md'
      }}
      _active={{
        transform: 'translateY(0)'
      }}
      _focusVisible={{ boxShadow: '0 0 0 2px var(--chakra-colors-brand-200)' }}
      fontSize="xs"
      {...rest}
    >
      {children}
    </Button>
  )
}

type PrimaryButtonProps = ButtonProps

export const PrimaryButton: React.FC<PrimaryButtonProps> = ({ children, colorScheme, ...rest }) => {
  return (
    <Button
      height={{ base: 10, md: 12 }}
      rounded="0"
      backgroundColor="brand.500"
      border="1px solid"
      borderColor="transparent"
      color="white"
      textTransform="uppercase"
      letterSpacing="0.02em"
      fontWeight="700"
      _hover={{
        backgroundColor: 'brand.600',
        transform: 'translateY(-1px)',
        shadow: 'md'
      }}
      _active={{
        backgroundColor: 'brand.700',
        transform: 'translateY(0)'
      }}
      _focusVisible={{ boxShadow: '0 0 0 2px var(--chakra-colors-brand-200)' }}
      fontSize="xs"
      {...rest}
    >
      {children}
    </Button>
  )
}

type SecondaryButtonProps = {} & ButtonProps

export const SecondaryButton: React.FC<SecondaryButtonProps> = ({
  children,
  colorScheme,
  ...rest
}) => {
  return (
    <Button
      height={{ base: 10, md: 12 }}
      rounded="0"
      backgroundColor="transparent"
      border="1px solid"
      borderColor={colorScheme ? `${colorScheme}.300` : 'gray.300'}
      color={colorScheme ? `${colorScheme}.500` : 'gray.700'}
      textTransform="uppercase"
      letterSpacing="0.02em"
      fontWeight="500"
      _hover={{
        backgroundColor: colorScheme ? `${colorScheme}.50` : 'brand.50',
        borderColor: colorScheme ? `${colorScheme}.500` : 'brand.500',
        color: colorScheme ? `${colorScheme}.500` : 'brand.500'
      }}
      _active={{
        backgroundColor: colorScheme ? `${colorScheme}.100` : 'gray.100',
        borderColor: colorScheme ? `${colorScheme}.400` : 'gray.400'
      }}
      _focusVisible={{ boxShadow: '0 0 0 2px var(--chakra-colors-brand-200)' }}
      fontSize="xs"
      colorScheme={colorScheme}
      {...rest}
    >
      {children}
    </Button>
  )
}

export const BoxButton: React.FC<StackProps & { title: string; icon?: any }> = ({
  children,
  title,
  icon,
  ...rest
}) => {
  return (
    <VStack
      flex={1}
      rounded="0"
      px={1}
      py={3}
      transition="all 0.2s"
      cursor="pointer"
      _hover={{ bg: 'gray.200', transform: 'translateY(-1px)' }}
      _focusVisible={{ boxShadow: '0 0 0 2px var(--chakra-colors-brand-200)' }}
      bg="gray.100"
      spacing={1}
      {...rest}
    >
      <Icon as={icon} fontSize={19} color="gray.600" />
      <Text>
        <Text fontSize="x-small" as="span" textTransform="uppercase" letterSpacing="0.02em">
          {title}
        </Text>
      </Text>
    </VStack>
  )
}
